import { render, staticRenderFns } from "./text-field.vue?vue&type=template&id=38656a38&"
import script from "./text-field.vue?vue&type=script&lang=js&"
export * from "./text-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports